export default {
	UPDATE_ACTIVE_ORGANISATION(state, organisation) {
    localStorage.setItem('last_organisation', JSON.stringify(organisation))
    state.organisation = organisation
  },
  UPDATE_ORGANISATION_USER(state, user) {
    localStorage.setItem('last_organisation_user', JSON.stringify(user))
    state.organisation_user = user
    if (user) {
      state.user_permissions = user.role.permissions ? user.role.permissions : []
    }
  },
  UPDATE_AVAILABLE_REPORTS(state, results) {
    state.dpr_reports = results
  },
  SET_UNREAD_NOTIFICATIONS(state, unread_notifications) {
    state.unread_notifications = unread_notifications
  },
  UPDATE_UNREAD_NOTIFICATIONS(state) {
    if(state.unread_notifications) {
      state.unread_notifications = state.unread_notifications - 1 
    }
  }
}